import { render } from "./ThoughtCard.vue?vue&type=template&id=bd963dfe"
import script from "./ThoughtCard.vue?vue&type=script&lang=js"
export * from "./ThoughtCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/armenium/56-free-school-street/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__